import * as types from "./types";

export const setUserObject = (user) =>(dispatch) => {
    return dispatch({
            type: types.SET_USER,
            payload: {user : user}
        });

}
